<template>
  <div>
    <v-row class="justify-center" v-if="item">
      <v-btn
          x-large
          width="70%"
          color="primary"
          @click="confirmAction"
          dark
          :disabled="confirmDisabled"
      >
        {{ confirmText }}
      </v-btn>
    </v-row>

    <v-row class="justify-center pt-10">
      <v-btn
          width="50%"
          @click="cancelAction"
          depressed
          class="grey--text mb-15"
          :class="cancelClass"
      >
        {{ cancelText }}
      </v-btn>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "ConfirmCancelButtons",
  props: {
    confirmAction: Function,
    cancelAction: Function,
    item: Object,
    cancelClass: {
      type: String,
      default: 'mb-15',
    },
    cancelText: {
      type: String,
      default: 'Cancel',
    },
    confirmText: {
      type: String,
      default: 'Confirm',
    },
    confirmDisabled: Boolean,
  },
};
</script>
